import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingComponent } from './landing/landing.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NoAccessComponent } from './no-access/no-access.component';
import { AuthGuard } from './services/auth.guard';
import { FeatureFlagGuard } from './services/feature-flag.guard';
import { PayCurveFiscalYearGuard } from './services/pay-curve-fiscal-year.guard';
import { TerritoryBudgetsComponent } from './territory-budgets/territory-budgets.component';
import { Capacitymodel360Component } from './capacitymodel360/capacitymodel360.component';
import { DetailedUploadComponent } from './detailed-upload/detailed-upload.component';
import { FinalQuotaListComponent } from './final-quota-list/final-quota-list.component';
import { QuotaInputComponent } from './quota-input/quota-input.component';
import { QuotaInputGicComponent } from './quota-input-gic/quota-input-gic.component';
import { EditDetailedUploadComponent } from './edit-detailed-upload/edit-detailed-upload.component';
import { EditFinalQuotaComponent } from './edit-final-quota/edit-final-quota.component';
import { EditQuotaInputComponent } from './edit-quota-input/edit-quota-input.component';
import { UploadComponent } from './upload/upload.component';
import { UploadRequestsComponent } from './upload-requests/upload-requests.component';
import { DownloadTemplateComponent } from './download-template/download-template-component';
import { DownloadManualTemplateComponent } from './download-manual-templates/download-manual-template-component';
import { QuotaInputManualGicComponent } from './quota-input-manual-gic/quota-input-manual-gic.component';
import { UploadManualComponent } from './upload-manual/upload-manual.component';
import { UploadManualRequestsComponent } from './upload-manual-requests/upload-manual-requests.component';
import { AccessControllerComponent } from './access-controller/access-controller.component';
import { EditAccessComponent } from './edit-access/edit-access.component';
import { EditAccessControllerComponent } from './edit-access-controller/edit-access-controller.component';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import {ArchivefileListComponent} from './archivefile-list/archivefile-list.component';
import { RolePlanTypeMappingComponent } from './role-plan-type-mapping/role-plan-type-mapping.component';
import { AddRolePlanTypeMappingComponent } from './add-role-plan-type-mapping/add-role-plan-type-mapping.component';
import { EditRolePlanTypeMappingComponent } from './edit-role-plan-type-mapping/edit-role-plan-type-mapping.component';
import { RolePayCurveMappingComponent } from './role-pay-curve-mapping/role-pay-curve-mapping.component';
import { AddRolePayCurveMappingComponent } from './add-role-pay-curve-mapping/add-role-pay-curve-mapping.component';
import { EditRolePayCurveMappingComponent } from './edit-role-pay-curve-mapping/edit-role-pay-curve-mapping.component';


 

const routes: Routes = [
  // { path: 'home', component: Capacitymodel360Component, canActivate: [AuthGuard] },
  { path: 'login', component: LandingComponent },
  { path: 'TerritoryBudgets', component: TerritoryBudgetsComponent },
  { path: 'dashboard', component: DashboardComponent },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'DetailedUpload', component: DetailedUploadComponent },
  { path: 'FinalQuotaList', component: FinalQuotaListComponent },
  { path: 'QuotaInput', component: QuotaInputComponent },
  { path: 'QuotaInputGic', component: QuotaInputGicComponent },
  {path:  'QuotaInputManualGic', component:QuotaInputManualGicComponent},
  { path: 'Upload', component: UploadComponent },
  { path: 'UploadRequests', component: UploadRequestsComponent },
  { path: 'EditDetailedUpload', component: EditDetailedUploadComponent },
  { path: 'EditFinalQuota', component: EditFinalQuotaComponent },
  { path: 'EditQuotaInput', component: EditQuotaInputComponent },
  { path: 'DownloadTemplate', component: DownloadTemplateComponent },
  {path:  'DownloadManualTemplate', component:DownloadManualTemplateComponent},
  { path: 'UploadManual', component:UploadManualComponent},
  { path: 'UploadManualRequests', component:UploadManualRequestsComponent},
  { path: 'AccessController', component:AccessControllerComponent, canActivate: [FeatureFlagGuard], data: { featureFlag: 'accountManagementEnabled' } },
  {path: 'EditAccess', component:EditAccessComponent, canActivate: [FeatureFlagGuard], data: { featureFlag: 'accountManagementEnabled' } },
  {path: 'EditAccessController',component:EditAccessControllerComponent, canActivate: [FeatureFlagGuard], data: { featureFlag: 'accountManagementEnabled' } },
  { path: 'AccessDenied', component: AccessDeniedComponent },
  { path: 'ArchivefileList',component:ArchivefileListComponent},
  // Mapping Configuration is a pay-curve-era area: only reachable from
  // environment.payCurveMinFiscalYear (CY27) onwards.
  { path: 'RolePlanTypeMapping', component: RolePlanTypeMappingComponent, canActivate: [PayCurveFiscalYearGuard] },
  { path: 'AddRolePlanTypeMapping', component: AddRolePlanTypeMappingComponent, canActivate: [PayCurveFiscalYearGuard] },
  { path: 'EditRolePlanTypeMapping', component: EditRolePlanTypeMappingComponent, canActivate: [PayCurveFiscalYearGuard] },
  { path: 'RolePayCurveMapping', component: RolePayCurveMappingComponent, canActivate: [PayCurveFiscalYearGuard] },
  { path: 'AddRolePayCurveMapping', component: AddRolePayCurveMappingComponent, canActivate: [PayCurveFiscalYearGuard] },
  { path: 'EditRolePayCurveMapping', component: EditRolePayCurveMappingComponent, canActivate: [PayCurveFiscalYearGuard] }
];

const isIframe = window !== window.parent && !window.opener;
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers: [AuthGuard, FeatureFlagGuard]
})
export class AppRoutingModule { }
